
const brlFormat = new Intl.NumberFormat(`pt-BR`, {
    currency: `BRL`,
    style: 'currency',
  });

export default brlFormat